import { useEffect, useState } from 'react';
import useClient from 'api/client';
import { useParams } from 'react-router-dom';
import queryShareDataset from 'api/ShareObject/queryShareDataset';
import queryDatasetDetails from 'api/Dataset/queryDatasetDetails';

interface DisplayData {
    label: string;
    value: string;
}
export default function useDatasetInformation() {
    const client = useClient();
    const [loading, setLoading] = useState(true);
    const [displayData, setDisplayData] = useState<DisplayData[]>([]);
    const [description, setDescription] = useState<string>('');
    const [datasetLabel, setDatasetLabel] = useState<string>('');
    const [datasetUri, setDatasetUri] = useState<string>('');
    const [error, setError] = useState<boolean>(false);
    const params = useParams();

    const parseStatisctics = (tables: string, locations: string) => {
        return (parseInt(tables, 10) + parseInt(locations, 10)).toString();
    };
    useEffect(() => {
        if (client) {
            setLoading(true);
            if (params.uri) {
                client.query(queryShareDataset(params.uri)).then((response) => {
                    if (!response.errors) {
                        setDatasetLabel(
                            response.data.getShareObject.dataset.datasetName,
                        );
                        setDatasetUri(
                            response.data.getShareObject.dataset.datasetUri,
                        );
                        client
                            .query(
                                queryDatasetDetails(
                                    response.data.getShareObject.dataset
                                        .datasetUri,
                                ),
                            )
                            .then((datasetResponse) => {
                                if (!datasetResponse.errors) {
                                    setDescription(
                                        datasetResponse.data.getDataset
                                            .description,
                                    );
                                    setDisplayData([
                                        {
                                            label: 'Dataset',
                                            value: datasetResponse.data
                                                .getDataset.label,
                                        },
                                        {
                                            label: 'Tables and Folders',
                                            value: parseStatisctics(
                                                datasetResponse.data.getDataset
                                                    .statistics.tables,
                                                datasetResponse.data.getDataset
                                                    .statistics.locations,
                                            ),
                                        },
                                        {
                                            label: 'Business Owner',
                                            value: datasetResponse.data
                                                .getDataset.businessOwnerEmail,
                                        },
                                        {
                                            label: 'Dataset Admin Group',
                                            value: datasetResponse.data
                                                .getDataset.SamlAdminGroupName,
                                        },
                                        {
                                            label: 'Environment',
                                            value: datasetResponse.data
                                                .getDataset.environment.label,
                                        },
                                        {
                                            label: 'Organization',
                                            value: datasetResponse.data
                                                .getDataset.organization.label,
                                        },
                                        {
                                            label: 'AWS Accounts',
                                            value: datasetResponse.data
                                                .getDataset.AwsAccountId,
                                        },
                                        {
                                            label: 'Region',
                                            value: datasetResponse.data
                                                .getDataset.region,
                                        },
                                    ]);
                                }
                            });
                    } else {
                        setError(true);
                    }
                    setLoading(false);
                });
            }
        }
    }, [client, params.uri, setError]);
    return {
        displayData,
        description,
        datasetLabel,
        datasetUri,
        loading,
        error,
    };
}
